<template>
  <div class="main-body">

    <div class="out2">
      <div class="search2" style="padding: 10px 0px">

        <el-button size="mini" type="primary" icon="el-icon-plus" plain @click.native="toggleModalAdd">社区护士绑定设备</el-button>

        <div style="float:right">

          <el-select v-model="institutionCode" placeholder="请选择机构" style="margin-right:5px">
            <el-option
                v-for="item in arr_ins"
                :key="item.institutionCode"
                :label="item.userName"
                :value="item.institutionCode">
            </el-option>
          </el-select>

          <el-input v-model="userName" placeholder="选择社区护士" disabled style="width: 250px;margin-right: 5px">
            <el-button slot="append" icon="el-icon-search" @click="getNurse"></el-button>
            <el-button slot="prepend" icon="el-icon-close" @click="clearNurse"></el-button>
          </el-input>

          <el-input size="mini"  placeholder="输入Imei号" v-model="imeiAll" clearable style="margin-right:5px;width:180px"></el-input>

          <el-button size="mini" type="primary" plain @click="getList(true)">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>

      <el-table ref="myTable" class="table" size="mini" v-loading="tableLoading"  :data="tableData" :height="th" border style="width: 100%;">
        <el-table-column prop="userName" label="用户名" width="100" fixed></el-table-column>
        <el-table-column prop="phone" label="手机号" width="150" :formatter="getPhoneStr"></el-table-column>
        <el-table-column prop="imeiAll" label="Imei号" width="180"></el-table-column>
        <el-table-column prop="imei" label="ID" width="140"></el-table-column>
        <el-table-column prop="iccid" label="ICCID" width="200"></el-table-column>
        <el-table-column label="手表类型" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.type == 1">H09/HX88/HX99</span>
            <span v-if="scope.row.type == 2">GK217/A30</span>
          </template>
        </el-table-column>
        <el-table-column prop="battery" label="电量" width="100"></el-table-column>
        <el-table-column prop="onLine2" label="在线状态" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.onLine2 == true">在线</span>
            <span v-if="scope.row.onLine2 == false" style="color: red;">离线</span>
          </template>
        </el-table-column>

        <el-table-column prop="zoneCodePathName" label="所在区域" width="300" ></el-table-column>

        <el-table-column prop="createTime" label="绑定时间" :formatter="timefilter" min-width="150"></el-table-column>

        <el-table-column fixed="right" label="操作" width="200px">
          <template slot-scope="scope">
            <el-button type="text" size="mini"  @click="showSetICCID(scope.$index, scope.row)" >设置ICCID</el-button>
            <el-button type="text" size="mini" @click="setData(scope.$index, scope.row)" >设置</el-button>
            <el-button type="text" size="mini" @click="getWatchData(scope.$index, scope.row)" >数据</el-button>
            <el-button type="text" size="mini" @click="RemoveBinding(scope.row)">解绑</el-button>
          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         :current-page.sync="currentPage"  @current-change="current_change"></el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="showModalAdd=false" v-on:getList="getList"></Add>


    <SOSSetPage ref="mySOSSetPage"  v-show="showModalSOSSetPage" v-on:closeSOSSetPage="closeSOSSetPage"></SOSSetPage>
    <WatchData ref="WatchData"  v-show="watchDataShow" v-on:closeWatchData="closeWatchData"></WatchData>

    <SetICCID ref="mySetICCID" v-show="setICCIDShow" v-on:closeSet="setICCIDShow=false" v-on:getList="getList"></SetICCID>

    <Nurse ref="myNurse" v-show="showModalNurse" v-on:closeNurse="showModalNurse=false" v-on:setNurse="setNurse"></Nurse>

  </div>
</template>

<script>

import { timeStr,timefilters } from "@/common/times";
import { hex_md5 } from "@/common/Base64MD5";
import {getGovernmentCode, getStaffCode} from "@/utils/auth";

import SOSSetPage from "../Comm/Set/SOSSetPage";
import WatchData from "../Comm/Data/WatchData";

import Add from "./AddNurse";
import SetICCID from "../Comm/Set/SetICCID"

import Nurse from "@/views/Nurse/Comm/Nurse";


export default {
  name: "Role",
  data() {
    return {
      tableLoading:false,

      showModalAdd:false,
      showModalSOSSetPage:false,
      watchDataShow:false,

      showModalNurse:false,
      setICCIDShow:false,

      tableData: [],
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,

      th: 0,

      userCode: "",
      userName:'',
      imeiAll: "",

      insType:3,
      userType:8,
      addFrom:'homeCare',

      arr_ins:[],
      institutionCode: '',

    };
  },
  components: {Add, SOSSetPage,WatchData,Nurse,SetICCID},
  created() {
    this.th = this.$store.state.tableHeight-70;

  },

  watch: {
    //监听全局变量
    "$store.state.tableHeight": function (val) {
      this.th = val-70;
    },
  },
  methods: {
    init(){

      this.getIns();
    },

    getIns(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Institution/ListType",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          type:this.insType,
        }
      }).then((response) => {

        if (response.data.error === 0) {
          this.arr_ins = response.data.data.list;
          if(this.arr_ins.length>0){
            this.institutionCode = this.arr_ins[0].institutionCode;
            this.getList();
          }
        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }

      })

    },


    toggleModalAdd: function () {
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myAdd.init(this.insType,this.institutionCode,this.userType,this.addFrom);
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },


    getPhoneStr(row,index,column){
      let str = "";
      if(column && column.length == 11){
        str = column.substring(0,3)+"****"+column.substring(7,11);
      }else{
        str = column;
      }
      return str;
    },


    getNurse(){
      this.showModalNurse = !this.showModalNurse;
      this.$refs.myNurse.init(this.insType,this.institutionCode);
    },
    setNurse(row){
      this.userCode = row.userCode;
      this.userName = row.name;
    },
    clearNurse(){
      this.userCode = '';
      this.userName = '';
    },


    getWatchData(index,row){
      this.$refs.WatchData.init(row);
      this.watchDataShow =!this.watchDataShow;
    },
    closeWatchData(){
      this.watchDataShow =!this.watchDataShow;
    },

    setData(index,row){
      this.$refs.mySOSSetPage.init(row);
      this.showModalSOSSetPage = !this.showModalSOSSetPage;
    },
    closeSOSSetPage(){
      this.showModalSOSSetPage =!this.showModalSOSSetPage;
    },

    showSetICCID(index,row){
      this.$refs.mySetICCID.init(row.deviceXiaodouCode,row.iccid);
      this.setICCIDShow =!this.setICCIDShow;
    },

    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },

    getList(isSearch){
      if(isSearch)this.currentPage=1

      this.tableLoading=true
      this.$axios({
        method: "post",
        url: this.$deviceUrl + "DeviceXiaodou/PageByGovCode",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          pageIndex: this.currentPage,
          pageSize: this.pageSize,

          userCode: this.userCode,
          userType:this.userType,
          imeiAll: this.imeiAll,
          governmentCode:getGovernmentCode(),

        },
      }).then((response) => {
        this.tableLoading=false
        if (response.data.error == 0) {

          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
          this.$nextTick(()=>{
            this.$refs.myTable.doLayout();
          })

        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },


    timefilter(row, column, cellValue) {
      return timefilters(cellValue);
    },

    RemoveBinding(row) {
      this.$confirm("您确定要解绑该用户的设备吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios({
          method: "post",
          url: this.$deviceUrl + "DeviceXiaodou/Delete2",
          data: {
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            deviceXiaodouCode: row.deviceXiaodouCode,
          },
        }).then((response) => {
          //console.log(response);
          if (response.data.error == 0) {
            this.getList();
          } else if (response.data.error == 1) {
            this.$message.error(response.data.message);
          }
        }).catch(function (error) {
          console.log(error);
        });
      }).catch(() => {
        //this.$message({type: "info", message: "已取消操作",});
      });
    },


  },
};
</script>

<style scoped>
</style>
